import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-essay-question-view',
  templateUrl: 'essay-question-view.component.html',
  styleUrls: ['./essay-question-view.component.scss', './_essay-question-view-theme.component.scss']
})
export class EssayQuestionViewComponent implements AfterViewInit {
  @Input() question: Question;
  @Input() questionCtrl: FormControl;

  loading$ = signal(false);

  immediateErrorMatcher = new ShowOnDirtyErrorStateMatcher();

  private cdr = inject(ChangeDetectorRef);

  ngAfterViewInit(): void {
    this.questionCtrl.statusChanges.subscribe((status) => {
      // Ensure view reflects updated state
      this.cdr.markForCheck();

      if (status === 'PENDING' && !this.loading$()) {
        this.loading$.set(true);
      } else if (status !== 'PENDING') {
        this.loading$.set(false);
      }
    });
  }

  onInput(): void {
    if (!this.questionCtrl.touched) {
      this.questionCtrl.markAsTouched();
    }
  }
}
